import React from "react";
import { Map } from "components/map";
import "./styles.scss";
import locale from "./fr.yml";
import NumberFormat from "react-number-format";
import Scrollchor from "react-scrollchor";

interface Props {
  name: string;
  colors: string[];
  description: string;
  language: string;
  genre: string[];
  sex: string;
  clipId: string;
  clipName: string;
  clipCount: number;
  count: number;
  municipalities: [];
  id: number;
}

function getMapFileName(artistName: string) {
  return artistName
    .toLowerCase()
    .replace(".", "")
    .split(" ")
    .join("_")
    .replace("î", "i");
}

export const ArtistBlock = (props: Props) => {
  return (
    <div className="ui vertical segment artist-block" id={"artist-" + props.id}>
      <div className="ui center aligned container title-wrapper">
        <img
          className="artist-image"
          src={require("../../images/portraits/portrait-" + props.id + ".png")}
        />
        <div className="title-container">
          <h2 className="ui small infographic header">
            {props.name}
            <Scrollchor to="top20" disableHistory>
              <i className="chevron up icon white" />
            </Scrollchor>
          </h2>
          <div className="artist-info">
            <div className="artist-genre">
              <b>GENRE:</b>{" "}
              {props.genre.map((g, i) => {
                return (
                  <span key={"genre-" + i}>
                    {g}
                    {props.genre.length > 0 && i < props.genre.length - 1
                      ? ", "
                      : ""}
                  </span>
                );
              })}
            </div>
            <div className="artist-language">
              <b>LANGUE:</b> {locale[props.language]}
            </div>
          </div>
        </div>
      </div>
      <div className="ui vertical segment" style={{ paddingTop: ".65em" }}>
        <div className="ui container">
          <Map
            originalSize={{
              width: 1917,
              height: 1355
            }}
            classes={props.colors}
            rasterPath={require("../../images/maps/ch-" +
              getMapFileName(props.name) +
              ".png")}
            vectorPath={require("../../images/maps/romandie.svg")}
          />
        </div>
      </div>
      <div
        className="ui text container"
        dangerouslySetInnerHTML={{ __html: props.description }}
      />
      <div className="ui vertical segment">
        <div className="ui text container">
          <h5 className="ui very small infographic header">
            Où {props.name} est-{props.sex === "f" ? "elle" : "il"}{" "}
            {props.sex === "f" ? "la" : "le"} plus populaire en Suisse romande?
          </h5>
          <div className="ui middle aligned list municipalities-top5">
            {props.municipalities.map((municipality: string, i: number) => {
              return (
                <div key={"municipality-top5-" + i} className="item">
                  <div className="content">
                    <div className="header">{municipality[0]}</div>
                    <NumberFormat
                      value={municipality[1]}
                      displayType="text"
                      thousandSeparator="'"
                    />{" "}
                    vues
                  </div>
                </div>
              );
            })}
          </div>
          <div>
            <div style={{ marginTop: "2em" }}>
              <Scrollchor to="analysis" disableHistory>
                <i className="small double angle down icon" />
                L'analyse des tendances 2019
              </Scrollchor>
            </div>
          </div>
        </div>
      </div>
      <div className="clip-container">
        <div className="ui text container">
          <div className="embed-container">
            <iframe
              width={560}
              height={315}
              src={"https://www.youtube.com/embed/" + props.clipId}
              frameBorder="0"
              allowFullScreen
            />
          </div>
          <div className="clip-info">
            <b>{props.clipName}</b>
            <br />
            <small>
              <NumberFormat
                value={props.clipCount}
                displayType="text"
                thousandSeparator="'"
              />{" "}
              vues en Suisse
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};
